import {CommonModule} from "@angular/common";
import {Component, forwardRef, Input, TemplateRef, ViewContainerRef} from '@angular/core';
import {MatButtonModule} from '@angular/material/button';
import {MatIconModule} from '@angular/material/icon';
import {MatListModule} from '@angular/material/list';
import {RouterModule} from '@angular/router';
import {SidenavService} from 'src/app/core/services/sidenav.service';
import {TemplatePortal} from '@angular/cdk/portal';
import {MenuPanelComponent} from '../menu-panel/menu-panel.component';
import {IMenuItem} from 'src/app/core/models/menu.model';

@Component({
  selector: 'app-menu-item',
  standalone: true,
  imports: [
    CommonModule,
    RouterModule,
    MatListModule,
    MatButtonModule,
    MatIconModule,
    forwardRef(() => MenuPanelComponent),
  ],
  templateUrl: './menu-item.component.html',
  styleUrl: './menu-item.component.css',
  // changeDetection: ChangeDetectionStrategy.OnPush,
})
export class MenuItemComponent {
  @Input() menuItem?: IMenuItem;

  constructor(
    private readonly sidenavService: SidenavService,
    private vcf: ViewContainerRef,
  ) {
  }

  openPanel(templateRef: TemplateRef<any>) {
    const portal = new TemplatePortal(templateRef, this.vcf);
    this.sidenavService.pushContent(portal, 'start');
  }

  onMenuItemClick() {
    this.sidenavService.clearContents('start');
  }
}
